import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { getMessageBus } from "./messageBusHandler";
const MessageBusContext = createContext({
    source: "jti-message-bus",
});
export const MessageBusProvider = ({ source, children }) => {
    const value = useMemo(() => ({ source }), [source]);
    return _jsx(MessageBusContext.Provider, { value: value, children: children });
};
export const MessageBusConsumer = MessageBusContext.Consumer;
const createEnvelope = (data, source) => {
    return Object.assign(Object.assign({}, data), { headers: Object.assign({ source }, data.headers) });
};
export const useMessageBus = () => {
    const context = useContext(MessageBusContext);
    const messageBus = getMessageBus();
    return {
        publish(topic, data, options) {
            const envelope = createEnvelope(data, context.source);
            messageBus.publish(topic, envelope, options);
        },
        subscribe(request) {
            return messageBus.subscribe(request);
        },
        unsubscribe(topic) {
            return messageBus.unsubscribe(topic);
        },
        getHistory() {
            return messageBus.getHistory();
        },
        removeHistoryItem(channel) {
            return messageBus.removeHistoryItem(channel);
        },
        getLastHistory(channel) {
            return messageBus.getLastHistory(channel);
        },
        get source() {
            return context.source;
        },
    };
};
//# sourceMappingURL=MessageBusProvider.js.map